import { jsx as C } from "react/jsx-runtime";
const l = ({
  width: o,
  height: t,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 21 14",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M20.336 6.3C19.3966 4.41983 17.9554 2.83619 16.1718 1.72431C14.3882 0.612425 12.3317 0.0156454 10.23 0C8.12831 0.0158712 6.07197 0.612743 4.28841 1.7246C2.50485 2.83646 1.06357 4.41997 0.123993 6.3C0.0427046 6.46075 0.000350952 6.63836 0.000350952 6.8185C0.000350952 6.99864 0.0427046 7.17625 0.123993 7.337C1.06339 9.21717 2.50463 10.8008 4.28823 11.9127C6.07183 13.0246 8.12826 13.6214 10.23 13.637C12.3317 13.6211 14.388 13.0243 16.1716 11.9124C17.9551 10.8005 19.3964 9.21703 20.336 7.337C20.4173 7.17625 20.4596 6.99864 20.4596 6.8185C20.4596 6.63836 20.4173 6.46075 20.336 6.3ZM10.23 11.934C9.21834 11.934 8.22941 11.634 7.38825 11.072C6.54709 10.5099 5.89149 9.71107 5.50435 8.77643C5.11721 7.84178 5.01591 6.81333 5.21328 5.82111C5.41064 4.8289 5.8978 3.91749 6.61314 3.20215C7.32849 2.4868 8.23989 1.99965 9.23211 1.80228C10.2243 1.60492 11.2528 1.70621 12.1874 2.09336C13.1221 2.4805 13.9209 3.1361 14.483 3.97726C15.045 4.81842 15.345 5.80735 15.345 6.819C15.345 8.17558 14.8061 9.4766 13.8468 10.4359C12.8876 11.3951 11.5866 11.934 10.23 11.934ZM10.23 3.409C9.92528 3.41328 9.62255 3.45869 9.32999 3.544C9.56985 3.87146 9.68462 4.27393 9.65355 4.67865C9.62249 5.08336 9.44764 5.46361 9.16062 5.75063C8.8736 6.03764 8.49336 6.21249 8.08864 6.24356C7.68393 6.27462 7.28145 6.15985 6.95399 5.92C6.76786 6.60629 6.80158 7.33367 7.05042 7.99979C7.29925 8.66591 7.75068 9.23725 8.34117 9.63342C8.93167 10.0296 9.63152 10.2307 10.3423 10.2083C11.053 10.186 11.7388 9.94137 12.3033 9.50889C12.8677 9.07642 13.2824 8.47786 13.4889 7.79743C13.6954 7.11699 13.6834 6.38893 13.4545 5.71569C13.2257 5.04244 12.7915 4.4579 12.213 4.0443C11.6346 3.6307 10.9411 3.40786 10.23 3.409Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as Content
};
